
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  emits: ["close", "retry"],
})
class ModalFailedAcceptOrder extends Vue.with(Props) {
  onCloseModal() {
    this.$emit("close");
    this.$emit("update:modelValue", false);
  }

  onRetryModal() {
    this.$emit("update:modelValue", false);
    this.$emit("retry");
  }
}
export default ModalFailedAcceptOrder;
